import CityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { corvallisConfig } from "./data";

export default function CorvallisPage() {
  return <CityPageTemplate config={corvallisConfig} />;
}